/* global axios */
import ApiClient from './ApiClient';

class InboxMembers extends ApiClient {
  constructor() {
    super('inbox_members', { accountScoped: true });
  }

  update({ inboxId, agentList, autoAssignDisabledIds }) {
    return axios.patch(this.url, {
      inbox_id: inboxId,
      user_ids: agentList,
      auto_assign_disabled_user_ids: autoAssignDisabledIds,
    });
  }

  handoff({ inboxId, fromUserId, toUserId }) {
    return axios.post(`${this.url}/${inboxId}/handoff`, {
      from_user_id: fromUserId,
      to_user_id: toUserId,
    });
  }
}

export default new InboxMembers();
